import { Board, CellType } from '@/game/tetrisEngine';
import { useMemo } from 'react';

interface TetrisBoardProps {
  board: Board;
}

const cellClass = (cell: CellType): string => {
  if (cell === '') return '';
  if (cell === 'ghost') return 'tetris-ghost';
  return `tetris-${cell}`;
};

interface Star {
  x: number;
  y: number;
  size: number;
  opacity: number;
  delay: number;
}

function useStars(count: number): Star[] {
  return useMemo(() => 
    Array.from({ length: count }, () => ({
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2.5 + 0.5,
      opacity: Math.random() * 0.7 + 0.3,
      delay: Math.random() * 4,
    })),
  [count]);
}

export function TetrisBoard({ board }: TetrisBoardProps) {
  const stars = useStars(60);

  return (
    <div className="tetris-board-wrapper">
      {/* Starfield background */}
      <div className="tetris-starfield">
        {stars.map((star, i) => (
          <div
            key={i}
            className="tetris-star"
            style={{
              left: `${star.x}%`,
              top: `${star.y}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              opacity: star.opacity,
              animationDelay: `${star.delay}s`,
            }}
          />
        ))}
        {/* Glow orbs */}
        <div className="tetris-glow-orb tetris-glow-orb--1" />
        <div className="tetris-glow-orb tetris-glow-orb--2" />
        <div className="tetris-glow-orb tetris-glow-orb--3" />
      </div>

      {/* Game grid */}
      <div
        className="tetris-grid"
        style={{
          gridTemplateColumns: `repeat(10, 1fr)`,
          aspectRatio: '10 / 20',
        }}
      >
        {board.flat().map((cell, i) => (
          <div
            key={i}
            className={`rounded-[2px] transition-colors duration-75 ${cell === '' ? 'tetris-cell-empty' : cellClass(cell)}`}
            style={{ aspectRatio: '1' }}
          />
        ))}
      </div>
    </div>
  );
}
